import { useRef } from "react";
import { API_CALLS } from "../../../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../../../redux";
import { validVideoFileTypes } from "../../../../../../../../utils";
import VideoMeta from "./VideoMeta";
import VideoPreview from "./VideoPreview";
import VideoUpload from "./VideoUpload";
import { HiddenInput } from "./style";

const Video = () => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { post_id } = useAppSelector((state) => state.posts);
  const { uploadedVideo, video_id } = useAppSelector(
    (state) => state.postVideo
  );

  return (
    <>
      {uploadedVideo.id ? (
        <>
          <VideoMeta />
          <VideoPreview video_id={video_id} />
        </>
      ) : (
        <VideoUpload fileInputRef={fileInputRef} />
      )}
      <HiddenInput
        type="file"
        onChange={(e) => {
          const files = e.target.files;
          if (files?.length) {
            API_CALLS.POSTVIDEO.uploadVideoToAPost({
              post_id,
              video: files[0],
              content_id: video_id,
            });
          }
        }}
        ref={fileInputRef}
        accept={validVideoFileTypes.join(",")}
      />
    </>
  );
};

export default Video;
